var path = '/modules/contacts/views/pages/details/invoices.tpl.html';
var html = "<contact-invoices ng-if=\"vm.contact\" contact=\"vm.contact\"></contact-invoices>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/views/pages/details/invoices.tpl.html
// module id = 2075
// module chunks = 1